import { AboveAllModal } from 'components/AboveAllModalOverlay/AboveAllModalOverlay'
import { FIXED_CHILDREN_MODAL_TRANSITION } from 'components/AboveAllModalOverlay/fixedChildrenModalTransition'
import { WideHeader } from 'components/ModalDrawer/WideHeader/WideHeader'
import { translate } from 'i18n/i18n'
import React from 'react'

export const ACTION_MENU_MODAL_ID = 'action-menu'

export const openActionMenu = (actions: React.ReactNode) => {
  AboveAllModal.open({
    modalId: ACTION_MENU_MODAL_ID,
    fullScreen: true,
    withCloseButton: false,
    padding: 0,
    transitionProps: FIXED_CHILDREN_MODAL_TRANSITION,
    children: <ActionMenuModal>{actions}</ActionMenuModal>,
    styles: {
      content: {
        marginLeft: 'env(safe-area-inset-left)',
        marginRight: 'env(safe-area-inset-right)',
        boxShadow: 'none',
      },
    },
  })
}

type ActionMenuModalProps = {
  children: React.ReactNode
  title?: string
}

export const ActionMenuModal: React.FC<ActionMenuModalProps> = ({ children, title }) => {
  const handleClose = () => {
    AboveAllModal.close(ACTION_MENU_MODAL_ID)
  }

  return (
    <>
      <WideHeader
        title={title || translate.phrases.placeholder('More Options')}
        onClose={handleClose}
        isSecondaryModal={false}
      />

      <div css={{ padding: 10, paddingTop: 0 }}>{children}</div>
    </>
  )
}
